import useIframe from '@hooks/useIframe';
import React from 'react';
import { Helmet } from 'react-helmet';
import S from './IframeHolder.styles';
import SectionTitle from '@stories/Components/Global/SectionTitle/SectionTitle';
const IframeHolder = ({ iframeTitle, iframeUrl, iFrameHeight, sectionTitle, width = 'default', }) => {
    const [refIframe, status] = useIframe(iframeUrl);
    return (React.createElement(S.Container, { layout: width, flush: 'none' },
        React.createElement(Helmet, null,
            React.createElement("link", { rel: "preconnect", href: iframeUrl })),
        sectionTitle && React.createElement(SectionTitle, { ...sectionTitle }),
        React.createElement(S.IframeWrapper, { "data-loaded": status === 'complete', "data-fixed-height": iFrameHeight ? 'true' : 'false' },
            React.createElement(S.Iframe, { ref: refIframe, frameBorder: "0", width: "100%", height: iFrameHeight ? `${iFrameHeight}px` : '100%', title: iframeTitle }))));
};
export default IframeHolder;
